import { Page, Text, View } from "@react-pdf/renderer";

import {
  getClinicAddress,
  getCrmParts,
  getMedFields,
  getPatientCpf,
  getPatientName,
  getPrescritorNome,
  NotificationDigitalFooter,
  NotificationStripe,
  notificationStyles as s,
  RECEITA_STRIPE,
  type NotificationPdfProps,
} from "./notificationShared";

type Props = NotificationPdfProps & {
  letra: "A" | "B" | "B2";
};

export function NotificationReceitaAB({
  letra,
  filterSpecialMedication,
  dataPdf,
  linkDocument,
  qrCodeDataUrl,
  qrCodeSncrDataUrl,
  sncrConsultaUrl,
}: Props) {
  const item = filterSpecialMedication?.[0];
  const med = getMedFields(item);
  const { crm, uf } = getCrmParts(dataPdf);
  const address = getClinicAddress(dataPdf);
  const stripe = RECEITA_STRIPE[letra];

  return (
    <Page size="A4" style={s.page}>
      <NotificationStripe color={stripe} />

      <View style={s.headerRow}>
        <View style={s.titleBlock}>
          <Text style={s.titleMain}>
            NOTIFICAÇÃO DE RECEITA{" "}
            <Text style={s.titleLetter}>{letra}</Text>
          </Text>
          <Text style={s.eletronica}>ELETRÔNICA</Text>
        </View>
        <View style={s.numeroWrap}>
          <Text style={s.numeroLabel}>N.º</Text>
          <Text style={s.numeroValue}>{med.sncrNumero || ""}</Text>
        </View>
      </View>

      <View style={s.twoCol}>
        <View style={s.col}>
          <View style={s.colHeader}>
            <Text style={s.colTitle}>Emitente</Text>
          </View>
          <View style={s.colBody}>
            <Text style={s.field}>
              Nome do prescritor:{" "}
              <Text style={s.value}>{getPrescritorNome(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              Inscrição no conselho profissional / UF:{" "}
              <Text style={s.value}>
                {crm && uf ? `${crm} / ${uf}` : ""}
              </Text>
            </Text>
            <Text style={s.field}>
              Endereço completo: <Text style={s.value}>{address}</Text>
            </Text>
            <Text style={s.field}>
              Telefone: <Text style={s.value}></Text>
            </Text>
          </View>
        </View>
        <View style={s.col}>
          <View style={s.colHeader}>
            <Text style={s.colTitle}>Paciente</Text>
          </View>
          <View style={s.colBody}>
            <Text style={s.field}>
              Nome: <Text style={s.value}>{getPatientName(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              CPF ou, se estrangeiro, passaporte:{" "}
              <Text style={s.value}>{getPatientCpf(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              Endereço completo: <Text style={s.value}></Text>
            </Text>
          </View>
        </View>
      </View>

      <View style={s.prescriptionBox}>
        <View style={s.prescriptionHeader}>
          <Text style={s.prescriptionTitle}>Prescrição</Text>
        </View>
        <View style={s.prescriptionBody}>
          <Text style={s.fieldSpaced}>
            Nome do medicamento ou substância:{" "}
            <Text style={s.value}>{med.nome}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Concentração: <Text style={s.value}>{med.concentracao}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Forma farmacêutica: <Text style={s.value}>{med.forma}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Quantidade: <Text style={s.value}>{med.quantidade}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Posologia: <Text style={s.value}>{med.posologia}</Text>
          </Text>
        </View>
      </View>

      <NotificationDigitalFooter
        linkDocument={linkDocument}
        qrCodeDataUrl={qrCodeDataUrl}
        qrCodeSncrDataUrl={qrCodeSncrDataUrl}
        sncrConsultaUrl={sncrConsultaUrl}
      />
    </Page>
  );
}
